export const getCourierDisplaySettingsModel = (data = {}) => {
    return {
        
        ShowBusinessDeliveryPriceInCourierApp: data.showBusinessDeliveryPriceInCourierApp,
        ShowOrderContentAtPickup: data.showOrderContentAtPickup,
        ShowCourierPaymentInApp: data.showCourierPaymentInApp,
        ShowCourierTipInApp: data.showCourierTipInApp,
        ShowLatestOrderReadinessTimeAtPickup : data.showLatestOrderReadinessTimeAtPickup,
        ShowCourierPerHourTipInApp : data.showCourierPerHourTipInApp,
        UseCoolingTimeToTargetTimeCalculationInCourierApp : data.useCoolingTimeToTargetTimeCalculationInCourierApp
    };
};